export const MSGraphParams = {
  appId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: window.location.origin,
  scopes: ["User.Read"],
  tenantId: process.env.REACT_APP_DIRECTORY_ID,
};

export const MSGraphParamsEmail = {
  appId: "00000003-0000-0000-c000-000000000000",
  redirectUri: window.location.origin,
  scopes: ["Mail.Send","Mail.ReadWrite"],
  tenantId: process.env.REACT_APP_DIRECTORY_ID,
};

export const AzureGraphParams = {
  appId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: window.location.origin,
  scopes: ["https://graph.windows.net/User.Read"],
  tenantId: process.env.REACT_APP_DIRECTORY_ID,
};

export const ProjectParams = {
  appId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: window.location.origin,
  scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`],
  tenantId: process.env.REACT_APP_DIRECTORY_ID,
};
